import api from "src/shared/api";
import {
  ErpPartnersActsResponse,
  IGetReconciliationActParams,
  ReconciliationActResponse,
} from "../types";

const getFileNameFromContentDisposition = (
  contentDisposition: string | null,
) => {
  if (!contentDisposition) {
    return null;
  }

  const encodedFileName = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i,
  )?.[1];

  if (encodedFileName) {
    try {
      return decodeURIComponent(encodedFileName);
    } catch {
      return null;
    }
  }

  return contentDisposition.match(/filename="([^"]+)"/i)?.[1] ?? null;
};

const erpPartnersActsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getErpPartnerAct: build.query<ErpPartnersActsResponse[], string | number>({
      query: (id) => ({
        url: `api/partners/${id}/finances/acts`,
        method: "GET",
      }),
      transformResponse: (response: { data: ErpPartnersActsResponse[] }) =>
        response.data,
    }),

    downloadReconciliationAct: build.mutation<
      ReconciliationActResponse,
      IGetReconciliationActParams
    >({
      query: ({ partnerId, contractId, date_from, date_to }) => ({
        url: `api/partners/contracts/${partnerId}/${contractId}/reconciliation-act`,
        method: "GET",
        params: {
          date_from,
          date_to,
        },
        responseHandler: async (response) => {
          if (!response.ok) {
            return response.json();
          }

          const blob = await response.blob();

          return {
            blob,
            fileName: getFileNameFromContentDisposition(
              response.headers.get("Content-Disposition"),
            ),
          };
        },
      }),

      transformResponse: ({
        blob,
        fileName,
      }: {
        blob: Blob;
        fileName: string | null;
      }) => ({
        fileUrl: URL.createObjectURL(blob),
        fileName,
      }),
    }),
  }),
});

export const {
  useGetErpPartnerActQuery,
  useDownloadReconciliationActMutation,
} = erpPartnersActsApi;
